import { render } from "./Gravatar.vue?vue&type=template&id=6e7d9e40"
import script from "./Gravatar.vue?vue&type=script&lang=js"
export * from "./Gravatar.vue?vue&type=script&lang=js"
script.render = render

export default script